import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import makeSelectVolumeDiscountPage from './selectors';
import reducer from './reducer';
import saga from './saga';
import { setIsVDAboveATCRendered } from '../actions';
import { addToCartSuccess } from '../Init/actions';
import {
  updateVDSelectedVariants,
  updateVDTotalDisplayOfferValue,
  updateIsVDVariantSelectorInViewForAboveATC,
  updateSelectedVDOptionIndex,
  updateSelectedVDOption,
  updateVDOfferTheme,
  updateVDMrOfferID,
  updateVDPrimaryProduct,
} from './actions';
import makeSelectInit from '../Init/selectors';
import VD from '../../components/Embedded/VD';

import { goToCart } from '../../../common/navigation';

import {
  getVDVariantsToAdd,
  addOfferedVariantsToCart,
} from '../../../common/cart';

function VolumeDiscountPage(props) {
  const {
    volumeDiscountPage: {
      totalDisplayOfferValues,
      selectedVDOptionIndex,
      selectedVariants,
    },
    addToCartSuccessEvent,
    widgetID,
  } = props;

  const setSelectedVDOptionIndex = useCallback(
    newValue => {
      props.updateSelectedVDOptionIndex({
        updatedSelectedVDOptionIndex: newValue,
      });
    },
    [selectedVDOptionIndex],
  );

  const setSelectedVariants = useCallback(
    newValue => {
      props.updateVDSelectedVariants({
        updatedSelectedVariants: newValue,
      });
    },
    [selectedVariants],
  );

  const setTotalDiplayOfferValues = useCallback(
    newValue => {
      props.updateVDTotalDisplayOfferValue({
        updatedTotalDisplayOfferValues: newValue,
      });
    },
    [totalDisplayOfferValues],
  );

  useEffect(() => {
    if (props.theme.widgetPosition === 'above_atc') {
      props.setIsVDAboveATCRendered(true);
    }
    props.updateVDPrimaryProduct({
      updatedPrimaryProduct: props.primary,
    });
    props.updateVDMrOfferID({ updatedMrOfferID: props.mrOfferID });

    return () => props.setIsVDAboveATCRendered(false);
  }, []);

  return (
    <VD
      isAdmin={false}
      isAdminMobileTab={false}
      mrOfferID={props.mrOfferID}
      primary={props.primary}
      theme={props.theme}
      vdOptions={props.vdOptions}
      isVDMultipleVariantsSelectable={props.isVDMultipleVariantsSelectable}
      discountType={props.discountType}
      currencyFormat={props.currencyFormat}
      currencySymbol={props.currencySymbol}
      getVDVariantsToAdd={getVDVariantsToAdd}
      addOfferedVariantsToCart={addOfferedVariantsToCart}
      goToCart={goToCart}
      addToCartSuccessEvent={addToCartSuccessEvent}
      priceRoundType={props.priceRoundType}
      discountRoundType={props.discountRoundType}
      selectedVariants={selectedVariants}
      setSelectedVariants={setSelectedVariants}
      selectedVDOptionIndex={selectedVDOptionIndex}
      setSelectedVDOptionIndex={setSelectedVDOptionIndex}
      totalDisplayValues={totalDisplayOfferValues}
      setTotalDiplayValues={setTotalDiplayOfferValues}
      updateIsVDVariantSelectorInViewForAboveATC={
        props.updateIsVDVariantSelectorInViewForAboveATC
      }
      updateSelectedVDOption={props.updateSelectedVDOption}
      updateVDOfferTheme={props.updateVDOfferTheme}
      isVDQuantityOptionSelected={props.isVDQuantityOptionSelected}
      vdSelectedQuantityOptionIndex={props.vdSelectedQuantityOptionIndex}
      widgetID={widgetID}
    />
  );
}

VolumeDiscountPage.propTypes = {
  //   dispatch: PropTypes.func.isRequired,
  volumeDiscountPage: PropTypes.object,
  mrOfferID: PropTypes.string.isRequired,
  primary: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  vdOptions: PropTypes.array.isRequired,
  isVDMultipleVariantsSelectable: PropTypes.bool.isRequired,
  discountType: PropTypes.string.isRequired,
  currencyFormat: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  addToCartSuccessEvent: PropTypes.func.isRequired,
  priceRoundType: PropTypes.string.isRequired,
  discountRoundType: PropTypes.string.isRequired,
  updateVDTotalDisplayOfferValue: PropTypes.func.isRequired,
  updateVDSelectedVariants: PropTypes.func.isRequired,
  updateIsVDVariantSelectorInViewForAboveATC: PropTypes.func.isRequired,
  updateSelectedVDOptionIndex: PropTypes.func.isRequired,
  updateSelectedVDOption: PropTypes.func.isRequired,
  updateVDOfferTheme: PropTypes.func.isRequired,
  updateVDMrOfferID: PropTypes.func.isRequired,
  updateVDPrimaryProduct: PropTypes.func.isRequired,
  setIsVDAboveATCRendered: PropTypes.func,
  isVDQuantityOptionSelected: PropTypes.bool.isRequired,
  vdSelectedQuantityOptionIndex: PropTypes.number.isRequired,
  widgetID: PropTypes.string.isRequired,
};

const mapStateToProps = createStructuredSelector({
  volumeDiscountPage: makeSelectVolumeDiscountPage(),
  init: makeSelectInit(),
});

function mapDispatchToProps(dispatch) {
  return {
    addToCartSuccessEvent: datapack => {
      dispatch(addToCartSuccess(datapack));
    },
    updateVDTotalDisplayOfferValue: datapack => {
      dispatch(updateVDTotalDisplayOfferValue(datapack));
    },
    updateVDSelectedVariants: datapack => {
      dispatch(updateVDSelectedVariants(datapack));
    },
    updateIsVDVariantSelectorInViewForAboveATC: datapack => {
      dispatch(updateIsVDVariantSelectorInViewForAboveATC(datapack));
    },
    updateSelectedVDOptionIndex: datapack => {
      dispatch(updateSelectedVDOptionIndex(datapack));
    },
    updateSelectedVDOption: datapack => {
      dispatch(updateSelectedVDOption(datapack));
    },
    updateVDOfferTheme: datapack => {
      dispatch(updateVDOfferTheme(datapack));
    },
    updateVDMrOfferID: datapack => {
      dispatch(updateVDMrOfferID(datapack));
    },
    updateVDPrimaryProduct: datapack => {
      dispatch(updateVDPrimaryProduct(datapack));
    },
    setIsVDAboveATCRendered: datapack => {
      dispatch(setIsVDAboveATCRendered({ isVDAboveATCRendered: datapack }));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'volumeDiscountPage', reducer });
const withSaga = injectSaga({ key: 'volumeDiscountPage', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(VolumeDiscountPage);
